import Ajax from "src/ajax"
import get from "lodash/get"

const path = "package-bundle"

/**
 * Actions
 */
const ACTION_REQUEST = `${path}/action-request`
const ACTION_REQUEST_SUCCESS = `${path}/action-success`
const ACTION_REQUEST_FAIL = `${path}/action-fail`
const ACTION_FETCH_DETAIL_SUCCESS = `${path}/action-fetch-detail-success`

const ADD_MEDICINE_BUNDLE = `${path}/add-medicine-bundle`
const REMOVE_MEDICINE_BUNDLE = `${path}/remove-medicine-bundle`
const UPDATE_MEDICINE_BUNDLE = `${path}/update-medicine-bundle`
const CLEAR_MEDICINE_BUNDLE = `${path}/clear-medicine-bundle`

/**
 * Action Creators
 */
export const selectMedicineBundle = (medicine) => ({
  type: ADD_MEDICINE_BUNDLE,
  payload: medicine,
})
export const removeMedicineBundle = (index) => ({
  type: REMOVE_MEDICINE_BUNDLE,
  payload: index,
})
export const updateMedicineBundle = (index, amount) => ({
  type: UPDATE_MEDICINE_BUNDLE,
  payload: { index, amount },
})
export const clearMedicineBundle = () => ({
  type: CLEAR_MEDICINE_BUNDLE,
})

/**
 * Side Effects
 */
export const fetchDetail = (_id) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: "GET",
      url: path + "/" + _id,
    }
    const response = await Ajax(options)
    const detail = response.data.package_bundle
    dispatch({ type: ACTION_FETCH_DETAIL_SUCCESS, payload: detail })
  } catch (error) {
    const error_text = get(error, "response.data.error")
    // set fetching = false + error text
    dispatch({ type: ACTION_REQUEST_FAIL, payload: error_text })
  }
}

export const createBundle = (payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: "POST",
      url: path,
      data: payload,
    }
    const response = await Ajax(options)
    dispatch({ type: ACTION_REQUEST_SUCCESS })
  } catch (error) {
    const error_array = get(error, "response.data.errors")
    dispatch({ type: ACTION_REQUEST_FAIL, payload: "error" })
    throw error_array
  }
}

export const editBundle = (_id, payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: "PUT",
      url: path + "/" + _id,
      data: payload,
    }
    const response = await Ajax(options)
    dispatch({ type: ACTION_REQUEST_SUCCESS })
  } catch (error) {
    const error_array = get(error, "response.data.errors")
    dispatch({ type: ACTION_REQUEST_FAIL, payload: "error" })
    throw error_array
  }
}

/**
 * Initial State
 */
const initialState = {
  detail: {},
  // step
  step: 1,
  // selected medicines
  bundle_medicines: [],
  // loading for create & edit
  processing: false,
  error: null,
}

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTION_REQUEST:
      return { ...state, processing: true, error: null }
    case ACTION_REQUEST_SUCCESS:
      return { ...state, processing: false }
    case ACTION_REQUEST_FAIL:
      return { ...state, processing: false, error: action.payload }
    case ACTION_FETCH_DETAIL_SUCCESS:
      return { ...state, processing: false, detail: action.payload }

    case ADD_MEDICINE_BUNDLE:
      return {
        ...state,
        bundle_medicines: [...state.bundle_medicines, action.payload],
      }
    case REMOVE_MEDICINE_BUNDLE:
      return {
        ...state,
        bundle_medicines: [...state.bundle_medicines].filter(
          (item, index) => index !== action.payload
        ),
      }
    case UPDATE_MEDICINE_BUNDLE:
      const { index, amount } = action.payload
      let temp = [...state.bundle_medicines]
      temp = temp.map((item, t_index) =>
        t_index === index ? { ...item, amount: amount } : item
      )
      return {
        ...state,
        bundle_medicines: temp,
      }
    case CLEAR_MEDICINE_BUNDLE:
      return { ...state, bundle_medicines: [] }
    default:
      return state
  }
}
